module.exports = __webpack_public_path__ + "img/cross_red.69b48e14.svg";